import { apiClient } from './client';
import type { TimeEntry } from '../types';

export const timeEntriesApi = {
  list: async (params: { ticketId?: string; technicianId?: string; billable?: boolean; page?: number; limit?: number } = {}) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v !== undefined && searchParams.set(k, String(v)));
    const res = await apiClient.get(`/time-entries?${searchParams}`);
    return res.data.data as { entries: TimeEntry[]; total: number; page: number; limit: number };
  },

  create: async (data: { ticketId: string; durationMinutes: number; description: string; billable?: boolean; startTime?: string; endTime?: string }) => {
    const res = await apiClient.post('/time-entries', data);
    return res.data.data.entry as TimeEntry;
  },

  startTimer: async (data: { ticketId: string; description?: string; billable?: boolean }) => {
    const res = await apiClient.post('/time-entries/timer/start', data);
    return res.data.data.entry as TimeEntry;
  },

  stopTimer: async (data?: { description?: string }) => {
    const res = await apiClient.post('/time-entries/timer/stop', data || {});
    return res.data.data.entry as TimeEntry;
  },

  getCurrentTimer: async () => {
    const res = await apiClient.get('/time-entries/timer/current');
    return res.data.data?.entry as TimeEntry | null;
  },

  update: async (id: string, data: { durationMinutes?: number; description?: string; billable?: boolean }) => {
    const res = await apiClient.put(`/time-entries/${id}`, data);
    return res.data.data.entry as TimeEntry;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/time-entries/${id}`);
  },
};
